module.exports = __webpack_public_path__ + "static/media/car_open_vid.e044a849.mp4";